import { useKeysLocked } from "@/tools/aggregate/portfolio-export/hooks/useKeysLocked";
import createLssFromMapSubTool from "@/tools/create/lss-from-map";
import { LargeSiteScreenTableHeader } from "@/tools/risk-bands/large-site-screen/components/LargeSiteScreenTableHeader";
import { LargeSiteScreenTutorial } from "@/tools/risk-bands/large-site-screen/components/LargeSiteScreenTutorial";
import { LssTutorialProvider } from "@/tools/risk-bands/large-site-screen/context/LssTutorialContext";
import { Tool, ToolProps } from "@/types/tools";
import { GatewayOutlined, GlobalOutlined } from "@ant-design/icons";
import { getConfig } from "@/features/branding";
import portfolioExportTool, { PortfolioExportTool } from "../../aggregate/portfolio-export";
const LargeSiteScreenToolRender = (props: ToolProps) => {
  const keysLocked = useKeysLocked();
  return <LssTutorialProvider isTutorialOpen={props.isTutorialOpen} data-sentry-element="LssTutorialProvider" data-sentry-component="LargeSiteScreenToolRender" data-sentry-source-file="index.tsx">
      <PortfolioExportTool key="large-site" mode="large-site" tableHeaderComponent={LargeSiteScreenTableHeader} {...props} data-sentry-element="PortfolioExportTool" data-sentry-source-file="index.tsx" />

      {!keysLocked && <LargeSiteScreenTutorial onClose={() => props.setIsTutorialOpen(false)} open={props.isTutorialOpen} setIsTutorialOpen={props.setIsTutorialOpen} setState={
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    () => {}} />}
    </LssTutorialProvider>;
};
const largeSiteScreenTool = {
  ...portfolioExportTool,
  id: "large-site-analysis",
  category: "comprehensive",
  keyPrefix: "comprehensive.largeSite",
  icon: <GatewayOutlined />,
  hasTutorial: true,
  banner: {
    // getConfig() is only available at runtime.
    enabled: () => !getConfig().pages.collections.enabled,
    icon: <GlobalOutlined />,
    tag: "Coming soon",
    description: "Geospatial visualisations of risk distribution across Large Sites will be available as an enhancement to the tool in June 2025."
  },
  render: (props: ToolProps) => <LargeSiteScreenToolRender {...props} />,
  subTools: [createLssFromMapSubTool]
} as Tool;
export default largeSiteScreenTool;